import { Controller } from "@hotwired/stimulus"

const FOLDER_SELECTOR = "[data-controller~='document-folders--folder']"
const EXPANDED_ATTRIBUTE = "data-document-folders--folder-expanded-value"

export default class extends Controller {
  static targets = ["toggleAllButton", "toggleAllLabel", "expandIcon", "collapseIcon"]
  static values = {
    allExpanded: Boolean,
    expandAllLabel: String,
    collapseAllLabel: String,
  }

  connect() {
    this._onFrameLoad = this._onFrameLoad.bind(this)
    this.element.addEventListener("turbo:frame-load", this._onFrameLoad)
    this._updateToggleAllButton()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this._onFrameLoad)
  }

  toggleAll(event) {
    event.preventDefault()
    this.allExpandedValue = !this.allExpandedValue
    this._applyToFolders(this.element)
    this._updateToggleAllButton()
  }

  // Subfolder rows are lazy-loaded turbo frames, so they only enter the DOM once
  // their parent expands. While "expand all" is active, expand them on arrival.
  _onFrameLoad(event) {
    if (!this.allExpandedValue) return

    this._applyToFolders(event.target)
  }

  _applyToFolders(root) {
    const value = String(this.allExpandedValue)

    root.querySelectorAll(FOLDER_SELECTOR).forEach((folder) => {
      folder.setAttribute(EXPANDED_ATTRIBUTE, value)
    })
  }

  _updateToggleAllButton() {
    if (!this.hasToggleAllButtonTarget) return

    const label = this.allExpandedValue ? this.collapseAllLabelValue : this.expandAllLabelValue
    this.toggleAllButtonTarget.title = label
    if (this.hasToggleAllLabelTarget) this.toggleAllLabelTarget.textContent = label
    if (this.hasExpandIconTarget)
      this.expandIconTarget.classList.toggle("hidden", this.allExpandedValue)
    if (this.hasCollapseIconTarget)
      this.collapseIconTarget.classList.toggle("hidden", !this.allExpandedValue)
  }
}
